var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 44,
    viewBox: "0 0 28 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hold",
    transform: "translate(-1262 -280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096",
    transform: "translate(409.571 -2.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 28,
    height: 28,
    rx: 10,
    transform: "translate(852.429 282.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M5.986,0h4.276a6.241,6.241,0,0,1,5.986,6.468V9.24a6.241,6.241,0,0,1-5.986,6.468H5.986A6.241,6.241,0,0,1,0,9.24V6.468A6.241,6.241,0,0,1,5.986,0Z",
    transform: "translate(858.429 288.575)",
    fill: "#f69722"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_1258",
    "data-name": "Path 1258",
    transform: "translate(864.429 305.429)",
    fill: "#f28f18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 3.5 C 1.172899961471558 3.5 0.5 2.827100038528442 0.5 2 C 0.5 1.172899961471558 1.172899961471558 0.5 2 0.5 C 2.827100038528442 0.5 3.5 1.172899961471558 3.5 2 C 3.5 2.827100038528442 2.827100038528442 3.5 2 3.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1 C 1.448600053787231 1 1 1.448600053787231 1 2 C 1 2.551399946212769 1.448600053787231 3 2 3 C 2.551399946212769 3 3 2.551399946212769 3 2 C 3 1.448600053787231 2.551399946212769 1 2 1 M 2 0 C 3.104569911956787 0 4 0.8954300880432129 4 2 C 4 3.104569911956787 3.104569911956787 4 2 4 C 0.8954300880432129 4 0 3.104569911956787 0 2 C 0 0.8954300880432129 0.8954300880432129 0 2 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(862.429 284.429)",
    fill: "#fa9f2b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    "data-name": "Ellipse 271",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(865.429 284.429)",
    fill: "#fa9f2b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_272",
    "data-name": "Ellipse 272",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(868.429 284.429)",
    fill: "#fa9f2b"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Hold-2",
    "data-name": "Hold",
    transform: "translate(1264 320)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fontSize: 12,
    fontFamily: "ArialMT, Arial",
    letterSpacing: "0.007em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hold")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.3d7d18dc78f5a1aa9587c05073fb6f75.svg";
export { ForwardRef as ReactComponent };